<template>
  <div class="panorama">
    <!-- <Navigation /> -->
    <div 
        class="content-container mp-container"
    >
        <div
            class="aside-left clickable"
            @click="navTo('rundgang')"
        ><img 
            src="/img/museum-pankow-grundriss_icon.png"
            class="plan-icon"
        ></div>
        <div class="main">
          <div
            class="panorama-container" 
          >
            <div class="room-audio">      
              <audio controls>
                <source :src="selected.audio" type="audio/mpeg">
                Your browser does not support the audio element.
              </audio>
            </div>
            <iframe 
                :src="panoramaSrc()" 
                width="100%"
                height="600px"
                style="border:none;"
            >
            </iframe>
          </div>
          <div 
            class="back-to-room clickable"
            @click="$router.go(-1)"
          >
            Zurück zum Raum ...
          </div>
        </div>
        <div
            class="aside-right "
        >
            <DetailList :current="panoramaNumber"/>
        </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import DetailList from '@/components/Detail-list'
// import Navigation from '@/components/Navigation'

export default {
  name: 'panorama-display',
  components: {
    DetailList,
    // Navigation
  },
  data () {
    return {
        panoramaNumber: null,
        panoramas: [
            {
                orderNumber: 1,
                title: 'Berliner Zimmer',
                src: 'https://mp-panoramas.culture-to-go.de/berliner-zimmer/index.html'
            },
            {
                orderNumber: 2,
                title: 'Wohnzimmer',
                src: 'https://mp-panoramas.culture-to-go.de/wohnzimmer/index.html'
            },
            {
                orderNumber: 3,
                title: 'Herrenzimmer',
                src: 'https://mp-panoramas.culture-to-go.de/herrenzimmer/index.html'
            }

        ]
    }
  },
  methods: {
    navTo(target) {
        this.$router.push(`/${target}`)
    },
    panoramaSrc() {
        return this.panoramas.find(p => p.orderNumber.toString() === this.panoramaNumber)
            ? this.panoramas.find(p => p.orderNumber.toString() === this.panoramaNumber).src
            : undefined
    }
  },
  computed: {
    ...mapGetters({
        rooms: 'getRoomsData',  
        player: 'getPlayerStatus',
        pagesData: 'getPagesData',
        selected: 'getSelectedRoom'
    }),
  },
  created () {
    this.panoramaNumber = this.$route.params.id
  }
}
</script>
<style lang="scss" scoped>
@import '@/scss/custom.scss';
.panorama {
    position: relative;
    min-height: 100vh;
    background-image: url('/img/museum-pankow-back-1400x900.jpg');
    background-repeat: no-repeat;
    background-position: top;
    background-size: cover;
}
.content-container {
    display: grid;
    grid-template-columns: auto 1fr auto;
    padding-top: 6rem;
    align-content: space-between;
    @media (max-width: 1300px) {
      grid-template-columns: auto 1fr;
    }
    @media (max-width: 880px) {
      display: block;
    }
}
.main {
    margin: 2rem 6rem 2rem 4rem;
    @media (max-width: 1300px) {
       margin: 2rem;
    }
}
.aside-left {
    margin: 2rem 1rem;
    @media (max-width: 880px) {
      display: none;
    }
    .plan-icon {
        max-width: 8rem;
    }
}
.aside-right {
  @media (max-width: 1300px) {
    display: none;
  }
}
.panorama-container {
  max-width: 1200px;
   background-color: $grey-light-80;
}
.back-to-room {
    font-size: 1.4rem;
    text-align: center;
    margin-top: 1rem;
    color: $red-dark;
    font-family: 'Titillium Web';
    font-weight: 600;

}
// player styling
.room-audio {
  // background-color: rgba(83,73,63,.65);
  padding: .4rem;
  audio {
    display: block;
    max-height: 2rem;
    margin: 0 auto;
  }
}
</style>